import { t } from 'i18next';
import { Drawer, DrawerContent } from './ui/drawer';
import { XIcon } from '../assets/X';
import { Button } from './ui/button';
import { useDeleteAddress } from '../modules/addresses/services/deleteAddress';
import { editAddressData } from '../store/selectors/editAddres';
import { useSelector } from 'react-redux';

type AddressDeleteProps = {
  open: boolean;
  setIsOpen: (state: boolean) => void;
};

export const DeleteAddressDrawer = ({
  open,
  setIsOpen,
}: AddressDeleteProps) => {
  const { deleteAddress, isPending } = useDeleteAddress();
  const editAddress = useSelector(editAddressData);

  const handleDelete = async () => {
    await deleteAddress(editAddress._id).then(() => {
      setIsOpen(false);
    });
  };

  return (
    <Drawer open={open} onOpenChange={setIsOpen}>
      <DrawerContent>
        <div className="px-4 pb-4 flex flex-col space-y-2">
          <div className="flex flex-row items-center justify-between">
            <p className="text-display-md max-w-[311px]">
              {t('delete-address')}
            </p>
            <div
              className="flex items-center justify-center h-6 w-6 rounded-full bg-button-secondary"
              onClick={() => setIsOpen(false)}
            >
              <XIcon className="text-text-icon-secondary" />
            </div>
          </div>

          <p className="text-body-sm-regular text-text-tertiary">
            {editAddress.title}
          </p>
          <div className="flex flex-row space-x-2 py-4">
            <Button
              className="h-12 bg-button-primary flex flex-row items-center justify-center rounded-xl shadow-none w-full"
              onClick={() => {
                handleDelete();
              }}
              disabled={isPending}
            >
              <p className="text-display-sm ">{t('yes')}</p>
            </Button>
            <Button
              className="h-12 bg-button-secondary flex flex-row items-center justify-center rounded-xl w-full shadow-none"
              onClick={() => setIsOpen(false)}
            >
              <p className="text-display-sm text-text-primary">{t('no')}</p>
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
